import { render, staticRenderFns } from "./Picture2.vue?vue&type=template&id=e791e6c0&scoped=true&"
import script from "./Picture2.vue?vue&type=script&lang=js&"
export * from "./Picture2.vue?vue&type=script&lang=js&"
import style0 from "./Picture2.vue?vue&type=style&index=0&id=e791e6c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e791e6c0",
  null
  
)

export default component.exports